export default __webpack_public_path__ + "static/media/pot.ecfcba34.svg";